import { render, staticRenderFns } from "./loading-button.vue?vue&type=template&id=6d0109e6&"
import script from "./loading-button.vue?vue&type=script&lang=ts&"
export * from "./loading-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports